import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';
import { colors } from 'styles/colors';

const defaultStyle = {
  backgroundColor: colors.trueBlack,

  '& > div > *:first-child': {
    marginRight: spacing.xsmall,
  },

  '& > div > #text': {
    fontSize: `${fonts.sizes.small}`,
    color: colors.white,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
  },
};

const useStyles = makeStyles({
  success: {
    ...defaultStyle,
  },
  error: {
    ...defaultStyle,
  },
  info: {
    ...defaultStyle,
  },
  warning: {
    ...defaultStyle,
  },
  close: {
    padding: spacing.xxxsmall,
  },
});

export default useStyles;
